import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoadingSpinner } from './components/ui/LoadingSpinner';
import { ConfigProvider } from './context/ConfigContext';
import { useDashboardConfig } from './hooks/useDashboardConfig';

const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const DataManagement = React.lazy(() => import('./pages/DataManagement'));

// Wrapper to provide ConfigProvider with route params
function DashboardWithConfig() {
  return (
    <ConfigProvider>
      <Dashboard />
    </ConfigProvider>
  );
}

function HomeRoute() {
  const { listConfigs } = useDashboardConfig();
  const configs = import.meta.env.DEV ? listConfigs() : [];

  if (configs.length > 0) {
    const latest = [...configs].sort(
      (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    )[0];

    return <Navigate to={`/dashboard/${latest.id}`} replace />;
  }

  return <DashboardWithConfig />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/dashboard" element={<HomeRoute />} />
          {/* Saved dashboard with persistence enabled */}
          <Route path="/dashboard/:id" element={<DashboardWithConfig />} />
          {/* Only allow Data Management in development mode */}
          {import.meta.env.DEV && (
            <Route path="/manage-data" element={
              <ConfigProvider>
                <DataManagement />
              </ConfigProvider>
            } />
          )}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}